import {
  ComponentRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { SpinnerComponent } from '../components/spinner/spinner.component';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[commonui-loader]',
  standalone: true,
})
export class LoaderIndicatorDirective {
  @HostBinding('class.with-loader') isVisible = false;

  @Input() set appLoader(showLoader: boolean) {
    if (showLoader) {
      this.showComponent();
    } else {
      this.hideComponent();
    }
  }

  private cmpRef: ComponentRef<SpinnerComponent> | null = null;

  private get contentEl(): HTMLElement {
    return this.el.nativeElement;
  }

  private get loaderEl(): HTMLElement {
    return this.cmpRef?.location.nativeElement;
  }

  private get loaderViewIdx(): number {
    if (this.cmpRef) {
      return this.vcr.indexOf(this.cmpRef.hostView);
    }
    return -1;
  }

  constructor(
    private readonly el: ElementRef,
    private readonly vcr: ViewContainerRef,
    private readonly renderer: Renderer2
  ) {}

  private showComponent(): void {
    if (this.isVisible) {
      return;
    }

    this.createComponent();
    this.changeLoaderElParent();
    this.isVisible = true;
  }

  private createComponent(): void {
    this.cmpRef = this.vcr.createComponent(SpinnerComponent);
  }

  private changeLoaderElParent(): void {
    this.renderer.appendChild(this.contentEl, this.loaderEl);
  }

  private hideComponent(): void {
    if (!this.isVisible) {
      return;
    }

    this.removeComponent();
    this.isVisible = false;
  }

  private removeComponent(): void {
    this.vcr.remove(this.loaderViewIdx);
  }
}
